import { render, staticRenderFns } from "./BindWeixin3.vue?vue&type=template&id=0dbd4400&scoped=true"
import script from "./BindWeixin3.vue?vue&type=script&lang=ts"
export * from "./BindWeixin3.vue?vue&type=script&lang=ts"
import style0 from "./BindWeixin3.vue?vue&type=style&index=0&id=0dbd4400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd4400",
  null
  
)

export default component.exports